import React from 'react';

import { Icon } from '@eika/icon';
import { ErrorLabel } from '@eika/label';

import './NoteFieldSummary.scss';

interface NoteFieldLayoutProps {
    placeholder: string;
    label?: string;
    note?: string;
    error?: string;
    icon?: ReturnType<typeof Icon>;
}

export const NoteFieldSummary: React.FC<NoteFieldLayoutProps> = ({ label, note, placeholder = '', error, icon }) => {
    if (error) {
        return (
            <div className="note-field-summary__container">
                <div className="note-field-summary__box">
                    <span className="note-field-summary__error" role="alert">
                        <ErrorLabel className="note-field-summary__error-label" text={error} />
                    </span>
                </div>
                {icon && <div className="note-field-summary__icon">{icon}</div>}
            </div>
        );
    }

    if (note) {
        return (
            <div className="note-field-summary__container">
                <div className="note-field-summary__box">
                    <span className="note-field-summary__label">{label}</span>
                    <span className="note-field-summary__note">{note}</span>
                </div>
                {icon && <div className="note-field-summary__icon">{icon}</div>}
            </div>
        );
    }

    return (
        <div className="note-field-summary__container">
            <span className="note-field-summary__placeholder">{placeholder}</span>
            {icon && <div className="note-field-summary__icon">{icon}</div>}
        </div>
    );
};
